// src/services/authService.js
import { jwtDecode } from "jwt-decode";

const getToken = () => localStorage.getItem("token");

const decodeToken = () => {
  try {
    const token = getToken();
    if (!token) return null;
    return jwtDecode(token);
  } catch (error) {
    console.error("Erreur lors du décodage du token :", error);
    return null;
  }
};

const getUserRoles = () => {
  const decoded = decodeToken();
  if (!decoded || !decoded.scopes) return [];
  return decoded.scopes
    .split(",")
    .map((role) => role.trim().toUpperCase());
};

const hasRole = (roleToCheck) => {
  const roles = getUserRoles();
  return roles.includes(roleToCheck.toUpperCase());
};

// Méthodes spécifiques
const isAdmin = () => hasRole("ADMIN");
const isRadiologue = () => hasRole("RADIOLOGUE");
const isTechnicien = () => hasRole("TECHNICIEN");
const isSecretaire = () => hasRole("SECRETAIRE");

const authService = {
  getToken,
  decodeToken,
  getUserRoles,
  hasRole,
  isAdmin,
  isRadiologue,
  isTechnicien,
  isSecretaire,
};

export default authService;
